import React from 'react'
import { connect } from 'react-redux'
import { MainPriceInput } from '../../../../components/FormBuilder'
import { getUserCurrency } from '../../../../reducers/userObject/selectors/object'
import { getIsCalculatingPrice } from '../../../../reducers/bookingCalendar/selectors/reservationForm'

const MainInputWithCurrency = ({ currency, isCalculating,disabled,isSideButtonDisabled, ...rest }) => {
  return (
    <MainPriceInput.ReduxField
      {...rest}
      isCalculating={isCalculating}
      currency={currency}
      disabled={disabled}
      isSideButtonDisabled={isSideButtonDisabled}
    />
  )
}

const MapCurrencyToProps = state => ({
  currency: getUserCurrency(state),
  isCalculating: getIsCalculatingPrice(state),
})

export default connect(MapCurrencyToProps)(MainInputWithCurrency)
